import BulkImportTypes from '../components/atoms/bulkImport/bulkImportTypes';
import { ButtonTheme } from '../components/atoms/button/button';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'documentationTable',
  isDragable: false,
  canChangePosition: false,
  sortingPositionIndex: 'sortingIndex',
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  isMultiSelectable:false,
  emptyMessage: "You don't have any doc yet.",
  getURL:'documentations/',
  newButton:false,
  bulkSelectable:false,
  fields: [
    
    {
      attributeName: 'title',
      label: 'Title',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canEdit: true,
      canCreate: true,
      canFilter: true,
      helpText: 'Title of the manual.',
      width: '60%',

    },
    {
      attributeName: 'url',
      label: 'URL',
      type: FormInputTypes.TEXT_INPUT.LINK,
      default: '',
      canOrder: true,
      canEdit: true,
      canCreate: false,
      canFilter: true,
      helpText: 'URL of the link.',
    },
  ],
};
